import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import chat from './modules/chat'
import websocket from './modules/websocket'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    chat,
    websocket
  },
  getters: {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    userName: state => (state.user.userInfo && state.user.userInfo.name) || '客服',
    sessions: state => state.chat.sessions,
    currentSessionId: state => state.chat.currentSessionId,
    currentSession: state =>
      state.chat.sessions.find(item => item.id === state.chat.currentSessionId) || null,
    currentMessages: state => {
      if (!state.chat.currentSessionId) return []
      return state.chat.messages[state.chat.currentSessionId] || []
    },
    totalUnread: state =>
      state.chat.sessions.reduce((sum, item) => sum + (item.unread || 0), 0),
    sessionsLoading: state => state.chat.loading,
    sessionsLoadStatus: state => state.chat.loadStatus,
    sessionsTotal: state => state.chat.total,
    messagesLoading: state => state.chat.messagesLoading,
    wsConnected: state => state.websocket.isConnected,
    wsSessionReady: state => state.websocket.sessionReady
  }
})

export default store
